import { Dispatch, SetStateAction } from 'react'
import Typography from 'antd/es/typography/Typography'
import { clearIdTokens } from 'services/authAxios'
import { LocalAuthStorageKey } from 'types'

import Button from 'components/atoms/Button'
import Modal from 'components/atoms/Modal'

interface OverCountVerifyOtpModalProps {
  open: boolean
  onCancel: () => void
  isMaxAttempts: boolean
  setRetryCount?: Dispatch<SetStateAction<number>>
  handleResendCode?: () => void
}

export default function OverCountVerifyOtpModal({
  open,
  onCancel,
  isMaxAttempts,
  setRetryCount,
  handleResendCode
}: OverCountVerifyOtpModalProps) {
  const handleOk = () => {
    if (isMaxAttempts) {
      localStorage.removeItem(LocalAuthStorageKey.PREVIOUS_SESSION_EXPIRED_PATH)
      localStorage.removeItem('last_activity')
      clearIdTokens()
      window.location.replace('/signin')
    } else {
      handleResendCode?.()
      onCancel()
      setRetryCount?.(0)
    }
  }

  return (
    <Modal open={open} onCancel={onCancel} centered footer={null}>
      <Typography className="text-center">
        {isMaxAttempts
          ? '一定回数以上誤ったコードが入力されたため、セッションを終了しました。再度ログインしてください。'
          : '規定回数を超えて誤入力がありました。新しい認証コードを再送してください。'}
      </Typography>
      <div className="flex justify-center items-center py-4">
        <Button
          type="primary"
          sizing="w-full h-[60px]"
          onClick={handleOk}
          className={isMaxAttempts ? '!w-[250px]' : '!min-w-[120px]'}
        >
          {isMaxAttempts ? 'ログイン画面に戻る' : '認証コードを再送信する'}
        </Button>
      </div>
    </Modal>
  )
}

OverCountVerifyOtpModal.defaultProps = {
  setRetryCount: () => {},
  handleResendCode: () => {}
}
